import React, { useEffect, useLayoutEffect, useRef, useState, useMemo } from 'react';
import { Bubble } from 'tea-component';
import classNames from 'classnames';
import { getLocale } from 'umi';
import { LANGUAGE_CN } from '@intelligence/_config/config';
import './index.scss';

const TextBubblesDbi = (props: any) => {
  const {
    text,
    rowNum,
    placement,
    style,
    className,
    onClick,
    depend = '',
    closeOnScroll = false,
    isSubText = false,
    bubbleProps,
    gameNameTag,
  } = props;
  // console.debug('TextBubblesDbi props:', props);
  const TextDom = useRef(null);
  const [shouldShowBubble, setShouldShowBubble] = useState(false);
  const [windowSize, setWindowSize] = useState<any>(null);
  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;

  useEffect(() => {
    window.addEventListener('resize', () => setWindowSize(window.innerWidth));
    return () => {
      window.removeEventListener('resize', () =>
        setWindowSize?.(window.innerWidth),
      );
    };
  }, []);

  // 因为有响应式,所以要监听屏幕宽度， 重新判断高度
  useLayoutEffect(() => {
    if (TextDom.current) {
      const { offsetHeight, scrollHeight, offsetWidth, scrollWidth } =
        TextDom.current;
      setShouldShowBubble(
        offsetHeight < scrollHeight || offsetWidth < scrollWidth,
      );
    }
  }, [text, depend, windowSize]);

  const textContent = useMemo(() => {
    return gameNameTag ? (
      <>
        <span
          className={classNames('dbi-text-exceeds-bubble-tag-value', {
            'dbi-text-exceeds-bubble-tag-value-blue-cn': gameNameTag?.type === 'blue' && isCN,
            'dbi-text-exceeds-bubble-tag-value-blue-en': gameNameTag?.type === 'blue' && !isCN,
            'dbi-text-exceeds-bubble-tag-value-yellow-cn': gameNameTag?.type === 'yellow' && isCN,
            'dbi-text-exceeds-bubble-tag-value-yellow-en': gameNameTag?.type === 'yellow' && !isCN,
          })}
        >
          {gameNameTag?.text}
        </span>
      </>
    ) : null;
  }, [text, gameNameTag, isCN]);

  return (
    <>
      {shouldShowBubble ? (
        <Bubble
          placement={placement ? placement : 'top'}
          dark
          content={text}
          style={style ? style : {}}
          closeOnScroll={closeOnScroll}
          {...(bubbleProps || {})}
        >
          <div
            className={classNames('dbh-text-exceeds-bubble', {
              className,
              'dbi-text-exceeds-bubble-tag-div': gameNameTag,
            })}
            onClick={() => {
              onClick?.();
            }}
          >
            {<>
              <span ref={TextDom}
                className={classNames({
                  'dbi-text-exceeds-bubble-tag-text': !isSubText,
                  'dbi-text-exceeds-bubble-tag-text-sub': isSubText,
                })}
                style={{
                  WebkitLineClamp: rowNum ? rowNum : 1,
                }}
              >{text}</span>
              {textContent}
            </>}
          </div>
        </Bubble>
      ) : (
        <>
          <div
            className={classNames('dbh-text-exceeds-bubble', {
              className,
              'dbi-text-exceeds-bubble-tag-div': gameNameTag,
            })}
            onClick={() => {
              onClick?.();
            }}
          >
            {<>
              <span ref={TextDom}
                className={classNames({
                  'dbi-text-exceeds-bubble-tag-text': !isSubText,
                  'dbi-text-exceeds-bubble-tag-text-sub': isSubText,
                })}
                style={{
                  WebkitLineClamp: rowNum ? rowNum : 1,
                }}
              >{text}</span>
              {textContent}
            </>}
          </div>
        </>
      )}
    </>
  );
};

export default TextBubblesDbi;
